import {
    ANAO,
    AORIGEM_CONTATO_AVULSOS,
    AORIGEM_CONTATO_CLIENTES,
    ASIM,
    ASITUACAO_FOLLOWUP_ABERTO,
    ASITUACAO_FOLLOWUP_ENCERRADO
} from 'consts';
import {
    handleIconMouseEnter,
    handleIconMouseLeave,
    uiStyles
} from 'lib/uiUtils';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    InputLabel,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { isFlagAtiva } from 'lib/configUtils';
import { safeSetState } from 'lib/reactUtils';
import { getDateInputValue } from 'lib/functions';
import { HistoryRounded } from '@material-ui/icons';
import { ComboPadrao, FormActions, FormTextArea } from 'views/Components';

class FollowUpForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    handleIconMouseEnter = handleIconMouseEnter;
    handleIconMouseLeave = handleIconMouseLeave;

    state = {
        followup: {
            codfollowup: '',
            codfollowuporig: '',
            assunto: '',
            texto: '',
            origemcontato: AORIGEM_CONTATO_AVULSOS,
            codcontato: '',
            situacao: ASITUACAO_FOLLOWUP_ABERTO,
            proximofollowup: '',
            comunicadoemail: ANAO
        },
        contatosAvulsos: [],
        clientesOptions: [],
        configCrm: {},
        isLoading: true,
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            assunto: {
                presence: {
                    allowEmpty: false,
                    message: 'Assunto obrigatório'
                },
                length: { maximum: 150 },
                type: 'string'
            },
            texto: {
                presence: {
                    allowEmpty: false,
                    message: 'Texto obrigatório'
                },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                const [combos, configCrm] = await Promise.all([
                    this.loadCombosContato(AORIGEM_CONTATO_AVULSOS, null),
                    this.loadConfigCrm()
                ]);

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    isLoading: false,
                    followup: this.getFollowUpDefault(),
                    contatosAvulsos: combos.contatosAvulsos,
                    clientesOptions: combos.clientesOptions,
                    configCrm
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadFollowUp(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o follow up:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao carregar o follow up!')
            );

            this.safeSetState({ isLoading: false });
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna o follow up padrão */
    getFollowUpDefault = () => ({
        codfollowup: '',
        codfollowuporig: '',
        assunto: '',
        texto: '',
        origemcontato: AORIGEM_CONTATO_AVULSOS,
        codcontato: '',
        situacao: ASITUACAO_FOLLOWUP_ABERTO,
        proximofollowup: '',
        comunicadoemail: ANAO
    });

    /* Carrega os contatos avulsos */
    loadContatosAvulsos = async (codcontato) => {
        const url = codcontato ? `/contato/listforchange/${codcontato}` : '/contato/active/true';
        const response = await api.get(url);
        const contatos = getResponseData(response);

        // garante ordem alfabética independente do que o backend retornar
        return [...contatos].sort((a, b) => String(a.nomecontato).localeCompare(String(b.nomecontato)));
    };

    /* Carrega os clientes */
    loadClientes = async (codcontato) => {
        const url = codcontato ? `/cliente/listforchange/${codcontato}` : '/cliente/active/true';
        const response = await api.get(url);
        const clientes = getResponseData(response);

        // garante ordem alfabética independente do que o backend retornar
        return [...clientes].sort((a, b) => String(a.fantasia).localeCompare(String(b.fantasia)));
    };

    /* Carrega os contatos avulsos e os clientes */
    loadCombosContato = async (origemcontato, codcontato) => {
        const [contatosAvulsos, clientesOptions] = await Promise.all([
            this.loadContatosAvulsos(origemcontato === AORIGEM_CONTATO_AVULSOS ? codcontato : null),
            this.loadClientes(origemcontato === AORIGEM_CONTATO_CLIENTES ? codcontato : null)
        ]);

        return { contatosAvulsos, clientesOptions };
    };

    /* Carrega as configurações do módulo CRM */
    loadConfigCrm = async () => {
        const response = await api.get('/followup/active/true?limit=1');

        return response?.data?.configCrm || {};
    };

    /* Carrega os follows up */
    loadFollowUp = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/followup/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Follow up não encontrado!');

            history.push(this.getBasePath());

            return;
        }

        const configCrm = response?.data?.configCrm || {};
        const combos = await this.loadCombosContato(registro.origemcontato, registro.codcontato);

        this.safeSetState({
            followup: {
                ...registro,
                codcontato: registro.codcontato || '',
                origemcontato: registro.origemcontato || AORIGEM_CONTATO_AVULSOS,
                situacao: registro.situacao || ASITUACAO_FOLLOWUP_ABERTO,
                proximofollowup: registro.proximofollowup || '',
                comunicadoemail: registro.comunicadoemail || ANAO
            },
            contatosAvulsos: combos.contatosAvulsos,
            clientesOptions: combos.clientesOptions,
            configCrm,
            isNewRecord: false,
            isView,
            isLoading: false
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, value } = event.target;

        this.setState(prevState => ({
            followup: {
                ...prevState.followup,
                [name]: name === 'assunto' ? String(value).toUpperCase() : value
            }
        }));
    };

    /* Muda a origem do contato */
    onChangeOrigemContato = (event) => {
        const origemcontato = Number(event.target.value);

        this.setState(prevState => ({
            followup: {
                ...prevState.followup,
                origemcontato,
                codcontato: ''
            }
        }));
    };

    /* Muda a situação */
    onChangeSituacao = (event) => {
        const situacao = Number(event.target.value);

        this.setState(prevState => ({
            followup: {
                ...prevState.followup,
                situacao
            }
        }));
    };

    /* Marca ou desmarca o "E-mail enviado" */
    onChangeComunicadoEmail = (event) => {
        const checked = event.target.checked;

        this.setState(prevState => ({
            followup: {
                ...prevState.followup,
                comunicadoemail: checked ? ASIM : ANAO
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de follow up */
    getPayloadFollowUp = () => {
        const { followup } = this.state;

        return {
            assunto: followup.assunto || '',
            texto: followup.texto || '',
            origemcontato: followup.origemcontato || AORIGEM_CONTATO_AVULSOS,
            codcontato: followup.codcontato || '',
            situacao: followup.situacao || ASITUACAO_FOLLOWUP_ABERTO,
            proximofollowup: followup.proximofollowup || '',
            comunicadoemail: followup.comunicadoemail || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { followup, isNewRecord } = this.state;
        const { history, loadFollowUp } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        if (followup.situacao === ASITUACAO_FOLLOWUP_ABERTO && !followup.proximofollowup) {
            this.handleOpenAlert('Data do próximo contato obrigatória para situação em aberto!');

            return;
        }

        try {
            const payload = this.getPayloadFollowUp();

            if (isNewRecord) {
                await api.post('/followup', payload);
            } else {
                await api.put(`/followup/${followup.codfollowup}`, payload);
            }

            if (loadFollowUp) loadFollowUp();

            history.push(this.getBasePath());
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar!')
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(this.getBasePath());
    };

    /* Clicar para abrir o histórico do follow up */
    onClickHistorico = () => {
        const { followup } = this.state;

        this.props.history.push(`${this.getBasePath()}/${followup.codfollowup}/historico`);
    };

    /* Caminho base da tela */
    getBasePath = () => {
        const path = this.props.match?.path || '/crm/followup/:id';

        return path.replace('/:id', '');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { followup, schema } = this.state;

        return validateSchemaFields(
            followup,
            schema,
            [
                'assunto',
                'texto'
            ]
        );
    };

    render() {
        const {
            clientesOptions,
            configCrm,
            contatosAvulsos,
            errors,
            followup,
            isLoading,
            isNewRecord,
            isView,
            messageAlert,
            openAlert
        } = this.state;

        const { actionIcon } = uiStyles;

        if (isLoading) {
            return (
                <CardContent>
                    <Typography variant="body1">
                        Carregando follow up...
                    </Typography>
                </CardContent>
            );
        }

        const isAvulso = followup.origemcontato === AORIGEM_CONTATO_AVULSOS;
        const isAberto = followup.situacao === ASITUACAO_FOLLOWUP_ABERTO;
        const mostraEmailEnviado = isFlagAtiva(configCrm, 'comunicafollowupemail');

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Follow up {followup.codfollowup}
                        </Typography>

                        {!isNewRecord && (
                            <Tooltip title="Histórico">
                                <HistoryRounded
                                    onClick={this.onClickHistorico}
                                    onMouseEnter={this.handleIconMouseEnter}
                                    onMouseLeave={this.handleIconMouseLeave}
                                    style={{
                                        ...actionIcon,
                                        fontSize: 32
                                    }}
                                />
                            </Tooltip>
                        )}
                    </Box>

                    <br />

                    <Box style={{ minWidth: 220 }}>
                        <FormLabel component="legend">
                            Origem
                        </FormLabel>

                        <RadioGroup
                            row
                            name="origemcontato"
                            value={followup.origemcontato}
                            onChange={this.onChangeOrigemContato}
                        >
                            <FormControlLabel
                                value={AORIGEM_CONTATO_AVULSOS}
                                label={<span>Contato avulso</span>}
                                control={
                                    <Radio
                                        size="small"
                                        color="primary"
                                        disabled={isView}
                                    />
                                }
                            />

                            <FormControlLabel
                                value={AORIGEM_CONTATO_CLIENTES}
                                label={<span>Cliente</span>}
                                control={
                                    <Radio
                                        size="small"
                                        color="primary"
                                        disabled={isView}
                                    />
                                }
                            />
                        </RadioGroup>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Assunto"
                            name="assunto"
                            value={followup.assunto || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.assunto || ''}
                            error={!!errors.assunto}
                            disabled={isView}
                            inputProps={{ maxLength: 150 }}
                            style={{
                                flex: 2,
                                minWidth: 260
                            }}
                        />

                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                flex: '0 1 180px',
                                minWidth: 180
                            }}
                        >
                            <InputLabel
                                htmlFor="select-situacao-followup"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Situação
                            </InputLabel>

                            <Select
                                label="Situação"
                                native
                                onChange={this.onChangeSituacao}
                                value={followup.situacao}
                                inputProps={{
                                    id: 'select-situacao-followup',
                                    name: 'situacao'
                                }}
                            >
                                <option
                                    key={ASITUACAO_FOLLOWUP_ABERTO}
                                    value={ASITUACAO_FOLLOWUP_ABERTO}
                                >
                                    {"Em aberto"}
                                </option>

                                <option
                                    key={ASITUACAO_FOLLOWUP_ENCERRADO}
                                    value={ASITUACAO_FOLLOWUP_ENCERRADO}
                                >
                                    {"Encerrado"}
                                </option>
                            </Select>
                        </FormControl>
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        style={{ gap: 12 }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            style={{ flex: 1, minWidth: 260 }}
                        >
                            <ComboPadrao
                                name={'codcontato'}
                                label={isAvulso ? 'Contato avulso' : 'Cliente'}
                                value={followup.codcontato}
                                onChange={this.onChange}
                                fieldId={isAvulso ? 'codcontato' : 'codcliente'}
                                listItems={isAvulso ? contatosAvulsos : clientesOptions}
                                fieldDescription={isAvulso ? 'nomecontato' : 'fantasia'}
                            />
                        </FormControl>

                        {isAberto && (
                            <TextField
                                label="Próximo follow up"
                                name="proximofollowup"
                                onChange={this.onChange}
                                type="date"
                                value={getDateInputValue(followup.proximofollowup)}
                                variant="outlined"
                                disabled={isView}
                                InputLabelProps={{ shrink: true }}
                                style={{
                                    minWidth: 180,
                                    flex: '0 1 180px'
                                }}
                            />
                        )}

                        {isAberto && mostraEmailEnviado && (
                            <FormControlLabel
                                label="Enviado e-mail"
                                control={
                                    <Checkbox
                                        checked={followup.comunicadoemail === ASIM}
                                        onChange={this.onChangeComunicadoEmail}
                                        color="primary"
                                        disabled={isView}
                                    />
                                }
                            />
                        )}
                    </Box>

                    <br />

                    <FormTextArea
                        label="Texto"
                        name="texto"
                        value={followup.texto}
                        onChange={this.onChange}
                        disabled={isView}
                        error={errors.texto}
                        minHeight={140}
                    />

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div >
        );
    }
};

FollowUpForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadFollowUp: PropTypes.func
};

export default FollowUpForm;